import { finderCountry } from './finderCountry';

const _ = require('lodash');
const replaceAll = require('string.prototype.replaceall');

export const phoneMask = function (cityCode, cities, countries) {
  const currentCountry = finderCountry(cityCode, cities);
  const finderMask = _.find(countries, (country) => country.code === currentCountry.Country_code);

  const regexFoo1 = replaceAll(finderMask.mask_phone, /([+()-])/g, '\\$1');
  const regexFoo2 = replaceAll(regexFoo1, '_', '\\d');

  return { maskRegexp: new RegExp(`^${regexFoo2}$`), mask: replaceAll(finderMask.mask_phone, '_', '9'), countryCode: currentCountry.Country_code };
};
